export const ROLES = {
  DOCTOR: "DOCTOR",
  PATIENT: "PATIENT",
  PHARMACIST: "PHARMACIST",
  OPHTHALMOLOGIST: "OPHTHALMOLOGIST",
  OPTICIAN: "OPTICIAN",
  EMS_DISPATCHER: "EMS_DISPATCHER",
  EMS_DRIVER: "EMS_DRIVER",
  BILLING_STAFF: "BILLING_STAFF",
  SYSTEM_ADMIN: "SYSTEM_ADMIN",
  SHAREHOLDER: "SHAREHOLDER",
  OPERATIONS_MANAGER:        "OPERATIONS_MANAGER",
  ORGANISATION_ADMINISTRATOR: "ORGANISATION_ADMINISTRATOR",
  PARTNER_ORG:               "PARTNER_ORG",
};

export function getDashboardRoute(role) {
  switch (role) {
    case ROLES.SYSTEM_ADMIN:    return '/dashboard/admin';
    case ROLES.DOCTOR:          return '/dashboard/doctor';
    case ROLES.PATIENT:         return '/dashboard/patient';
    case ROLES.PHARMACIST:      return '/dashboard/pharmacy';
    case ROLES.EMS_DISPATCHER:  return '/dashboard/ems';
    case ROLES.EMS_DRIVER:      return '/dashboard/ems';
    case ROLES.OPHTHALMOLOGIST: return '/dashboard/ophthalmology';
    case ROLES.OPTICIAN:        return '/dashboard/ophthalmology';
    case ROLES.BILLING_STAFF:   return '/dashboard/billing';
    case ROLES.SHAREHOLDER:         return '/dashboard/shareholder';
    case ROLES.OPERATIONS_MANAGER:         return '/dashboard/operations';
    case ROLES.ORGANISATION_ADMINISTRATOR: return '/dashboard/operations';
    case ROLES.PARTNER_ORG:               return '/dashboard/partner';
    default:                               return '/dashboard/admin';
  }
}

export function canAccess(role, allowedRoles) {
  return allowedRoles.includes(role);
}
